// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__9EDbg","approved":"Status_approved__NJ_2D","rejected":"Status_rejected__3SZNs","expired":"Status_expired__2WElH","label":"Status_label__LacXz"};